<template>
  <div>
    <b-overlay
      :show="loadingOverlay"
      rounded="sm"
    >
      <b-card no-body>
        <b-card-header class="pb-50">
          <h5>{{ $t('spot.relatorio.titlePrimeiroCard') }}</h5>
        </b-card-header>

        <!-- Filter Section -->
        <b-card-body>
          <b-row>
            <b-col
              cols="12"
              sm="6"
              md="4"
              lg="2"
              class="mb-2"
            >
              <label>{{ $t('spot.relatorio.labelDataIncial') }}</label>
              <flat-pickr
                v-model="dataBuscaFilter.inicio"
                class="form-control"
                :config="{ altInput: true, enableTime: false, altFormat: 'd/m/Y', locale: Portuguese}"
                :disabled="!!dataBuscaFilter.id"
              />
            </b-col>
            <b-col
              cols="12"
              sm="6"
              md="4"
              lg="2"
              class="mb-2"
            >
              <label>{{ $t('spot.relatorio.labelDataFinal') }}</label>
              <flat-pickr
                v-model="dataBuscaFilter.fim"
                class="form-control"
                :config="{ altInput: true, enableTime: false, altFormat: 'd/m/Y', locale: Portuguese}"
                :disabled="!!dataBuscaFilter.id"
              />
            </b-col>
            <b-col
              cols="12"
              sm="6"
              md="4"
              lg="2"
              class="mb-2"
            >
              <label>{{ $t('spot.relatorio.labelCoin') }}</label>
              <b-form-input
                id="coin"
                v-model="dataBuscaFilter.coin"
                placeholder="BTC, ETH..."
                class="form-control"
              />
            </b-col>
            <b-col
              v-show="false"
              cols="12"
              sm="6"
              md="4"
              lg="2"
              class="mb-2"
            >
              <label>{{ $t('spot.relatorio.fechamento.labelBase') }}</label>
              <b-form-select
                v-model="paridade"
                :options="optionsParidade"
                input-id="base-moeda"
              />
            </b-col>
            <b-col
              cols="12"
              sm="6"
              md="4"
              lg="2"
              class="mb-2"
            >
              <label>ID</label>
              <b-form-input
                id="ordem-id"
                v-model="dataBuscaFilter.id"
                placeholder="Ex: 1432987"
                class="form-control"
                type="number"
                min="1"
              />

            </b-col>
            <b-col
              cols="12"
              sm="6"
              md="4"
              lg="2"
              class="mb-2"
            >
              <label>{{ $t('spot.relatorio.fechamento.labelTrader') }}</label>
              <v-select
                v-model="dataBuscaFilter.agente"
                :options="agenteList"
                :label="'nome'"
                :reduce="agente => agente.id"
                class="w-100"
                :placeholder="$t('spot.relatorio.fechamento.selectTrader')"
              />
            </b-col>
            <b-col
              cols="12"
              sm="6"
              md="4"
              lg="2"
              class="mb-2 d-flex align-items-end"
            >
              <b-button
                v-ripple.400="'rgba(59, 130, 246, 0.15)'"
                variant="primary"
                block
                class="btn-icon"
                @click.prevent="buscarFiltro"
              >
                <feather-icon
                  icon="SearchIcon"
                  class="mr-1"
                  size="16"
                />
                <span>{{ $t('spot.relatorio.pesquisarBtn') }}</span>
              </b-button>
            </b-col>

          </b-row>
        </b-card-body>

        <!-- Statistics Cards -->
        <b-card-body class="border-top">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              lg="3"
              class="mb-3"
            >
              <div class="d-flex align-items-center justify-content-between p-3 bg-light-primary rounded">
                <div>
                  <h6 class="mb-1 text-muted">
                    {{ $t('futures.relatorio.fechamento.lucroRealizadoLiquido') }}
                  </h6>
                  <h3 class="mb-0 font-weight-bolder text-primary">
                    $ {{ resumo.totalLucro.toFixed(2) }}
                  </h3>
                </div>
                <div class="avatar bg-light-primary p-50">
                  <div class="avatar-content">
                    <feather-icon
                      icon="DollarSignIcon"
                      size="24"
                    />
                  </div>
                </div>
              </div>
            </b-col>

            <b-col
              cols="12"
              sm="6"
              lg="3"
              class="mb-3"
            >
              <div class="d-flex align-items-center justify-content-between p-3 bg-light-success rounded">
                <div>
                  <h6 class="mb-1 text-muted">
                    {{ $t('spot.relatorio.fechamento.textOperacoes') }}
                  </h6>
                  <h3 class="mb-0 font-weight-bolder text-success">
                    {{ totalCount }}
                  </h3>
                </div>
                <div class="avatar bg-light-success p-50">
                  <div class="avatar-content">
                    <feather-icon
                      icon="ActivityIcon"
                      size="24"
                    />
                  </div>
                </div>
              </div>
            </b-col>

            <b-col
              cols="12"
              sm="6"
              lg="3"
              class="mb-3"
            >
              <div class="d-flex align-items-center justify-content-between p-3 bg-light-info rounded">
                <div>
                  <h6 class="mb-1 text-muted">
                    {{ $t('futures.relatorio.fechamento.totalPnl') }}
                  </h6>
                  <h3 class="mb-0 font-weight-bolder text-info">
                    {{ resumo.totalPNL.toFixed(2) }}
                  </h3>
                </div>
                <div class="avatar bg-light-info p-50">
                  <div class="avatar-content">
                    <feather-icon
                      icon="TrendingUpIcon"
                      size="24"
                    />
                  </div>
                </div>
              </div>
            </b-col>

            <b-col
              cols="12"
              sm="6"
              lg="3"
              class="mb-3"
            >
              <div class="d-flex align-items-center justify-content-between p-3 bg-light-warning rounded">
                <div>
                  <h6 class="mb-1 text-muted">
                    {{ $t('futures.relatorio.fechamento.totalTaxa') }}
                  </h6>
                  <h3 class="mb-0 font-weight-bolder text-warning">
                    {{ resumo.totalTaxas.toFixed(2) }} <small>USDT</small>
                  </h3>
                </div>
                <div class="avatar bg-light-warning p-50">
                  <div class="avatar-content">
                    <feather-icon
                      icon="DivideIcon"
                      size="24"
                    />
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-overlay>

    <!-- Table Section -->
    <b-card
      no-body
      class="mt-2"
    >
      <b-overlay
        :show="loadingOverlay"
        rounded="sm"
      >
        <div class="table-responsive">
          <b-table
            ref="refListTable"
            :busy="loadingOverlay"
            :items="dataList"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            :empty-text="$t('spot.emptyText')"
            :sort-desc.sync="isSortDirDesc"
            striped
            class="position-relative mb-0"
          >

            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle" />
                <span class="ml-1">{{ $t('loading') }}</span>
              </div>
            </template>

            <template #cell(corretora)="data">
              <div class="exchange-cell">
                <img
                  :src="require(`@/assets/images/logo/${data.value.toLowerCase()}-logo.png`)"
                  :alt="data.value"
                  class="exchange-logo"
                >
                <span class="exchange-name">{{ data.value }}</span>
              </div>
            </template>

            <template #cell(paridade)="data">
              <div class="text-nowrap">
                <b-avatar
                  size="sm"
                  :src="getIcon(data.item.moedaTrade)"
                />
                <span class="mr-1">
                  {{ data.item.moedaTrade }}<span class="font-weight-light">/{{ data.item.paridadeTrade }}</span>
                </span>
              </div>
            </template>

            <template #cell(pnl)="data">
              <b-badge :variant="parseFloat(data.value) >=0 ? 'light-success' : 'light-danger'">
                {{ toFixed(data.item.pnl,4) }} {{ data.item.paridadeTrade }}
                <br>
                <small>
                  ({{ getPercentDiff(data.item.totalCompra, data.item.total) }}%)
                </small>
              </b-badge>
            </template>

            <template #cell(lucroLiquido)="data">
              <b-badge :variant="parseFloat(data.value) >=0 ? 'light-success' : 'light-danger'">
                {{ toFixed(data.value, 4) }} {{ data.item.paridadeTrade }}
              </b-badge>
            </template>

            <template #cell(taxaTotal)="data">
              <template v-if="data.value">
                {{ toFixed(data.value, 4) }} <small>{{ data.item.paridadeTrade }}</small>
              </template>
            </template>

            <template #cell(dataCriacaoCompra)="data">
              {{ formatDateTimeSemAnoBR(data.value) }}
            </template>

            <template #cell(dataExecucao)="data">
              {{ formatDateTimeSemAnoBR(data.value) }}
            </template>

            <template #cell(agente)="data">
              {{ data.value }} <br>
              <b-badge variant="light-primary">
                #{{ data.item.sinalId }}
              </b-badge>
            </template>

          </b-table>

          <div class="mx-2 mb-2">
            <b-row>

              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted">{{ $t('spot.textMuted', { from: paginationMeta.from, to: paginationMeta.to, of: paginationMeta.of }) }}</span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >

                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalCount"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>

              </b-col>

            </b-row>
          </div>

        </div>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>

import {
  BCard, BTable, BAvatar, BOverlay, BSpinner, BPagination, BRow, BCol, BBadge, BCardHeader, BCardBody, BButton, VBTooltip, BFormSelect, BFormInput,
} from 'bootstrap-vue'
import store from '@/store'
import utilsMixin from '@/mixins/utilsMixin'
import { formatDateTimeSemAnoBR, percentDiferenca, toIsoStringTimeZone } from '@/utils/filter'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import { Portuguese } from 'flatpickr/dist/l10n/pt'
import Ripple from 'vue-ripple-directive'
import fechamentoStoreModule from './fechamentoStoreModule'

const RELATORIO_FECHAMENTO_SPOT_STORE_MODULE_NAME = 'fechamento-relatorio-spot'

export default {

  components: {
    BCard,
    BTable,
    BAvatar,
    BPagination,
    BRow,
    BCol,
    BBadge,
    BCardHeader,
    BCardBody,
    flatPickr,
    BButton,
    BFormSelect,
    BSpinner,
    BFormInput,
    vSelect,
    BOverlay,
  },

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },

  mixins: [utilsMixin],

  data() {
    return {
      loadingOverlay: false,
      Portuguese,
      formatDateTimeSemAnoBR,
      percentDiferenca,
      perPage: 10,
      totalCount: 0,
      currentPage: 1,
      sortBy: 'dataExecucao,desc',
      isSortDirDesc: true,
      dataList: [],
      agenteList: [],
      optionsParidade: [
        { value: null, text: '' },
        { value: 'USDT', text: 'USDT' },
        { value: 'BTC', text: 'BTC' },
      ],
      paridade: null,
      dataBuscaFilter: {
        id: null,
        coin: null,
        agente: null,
        inicio: new Date(new Date().getFullYear(), new Date().getMonth(), '01'), // primeiro dia do mes atual
        fim: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
      },
      resumo: {
        totalLucro: 0,
        totalTaxas: 0,
        totalPNL: 0,
        totalPorcent: 0,
      },
    }
  },

  computed: {
    tableColumns() {
      return [
        { key: 'id', label: 'ID' },
        { key: 'corretora', label: this.$i18n.t('spot.tableHeader.corretora') },
        { key: 'paridade', label: this.$i18n.t('spot.relatorio.fechamento.tableHeader.paridade') },
        { key: 'totalCompra', label: this.$i18n.t('spot.relatorio.fechamento.tableHeader.totalCompra') },
        { key: 'total', label: this.$i18n.t('spot.relatorio.fechamento.tableHeader.total') },
        { key: 'pnl', label: this.$i18n.t('spot.relatorio.fechamento.tableHeader.pnl') },
        { key: 'taxaTotal', label: this.$i18n.t('spot.relatorio.fechamento.tableHeader.taxaTotal') },
        { key: 'lucroLiquido', label: this.$i18n.t('spot.relatorio.fechamento.tableHeader.lucroLiquido') },
        { key: 'dataCriacaoCompra', label: this.$i18n.t('spot.relatorio.fechamento.tableHeader.dataCriacaoCompra') },
        { key: 'dataExecucao', label: this.$i18n.t('spot.relatorio.fechamento.tableHeader.dataExecucao') },
        { key: 'agente', label: this.$i18n.t('spot.relatorio.fechamento.tableHeader.trader') },
      ]
    },
    paginationMeta() {
      const localItemsCount = this.$refs.refListTable ? this.$refs.refListTable.localItems.length : 0
      return {
        from: this.perPage * (this.currentPage - 1) + (localItemsCount ? 1 : 0),
        to: this.perPage * (this.currentPage - 1) + localItemsCount,
        of: this.totalCount,
      }
    },

    windowWidth() {
      return this.$store.state.app.windowWidth
    },
  },

  watch: {
    currentPage() {
      this.fetchList()
      this.$refs.refListTable.refresh()
    },
    // eslint-disable-next-line func-names
    'dataBuscaFilter.id': function (newId) {
      // Se ID foi limpo, reabilitar campos de data
      if (!newId) {
        this.dataBuscaFilter.inicio = new Date(new Date().getFullYear(), new Date().getMonth(), '01')
        this.dataBuscaFilter.fim = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
      }
    },
  },

  created() {
    if (!store.hasModule(RELATORIO_FECHAMENTO_SPOT_STORE_MODULE_NAME)) store.registerModule(RELATORIO_FECHAMENTO_SPOT_STORE_MODULE_NAME, fechamentoStoreModule)
    this.checkUrlParams()
    this.initializeData()
  },

  beforeDestroy() {
    if (store.hasModule(RELATORIO_FECHAMENTO_SPOT_STORE_MODULE_NAME)) store.unregisterModule(RELATORIO_FECHAMENTO_SPOT_STORE_MODULE_NAME)
  },

  methods: {
    checkUrlParams() {
      // Capturar parâmetros da URL
      const urlParams = new URLSearchParams(window.location.search)
      const idParam = urlParams.get('id')

      if (idParam) {
        // Preencher o campo ID com o valor da URL
        this.dataBuscaFilter.id = parseInt(idParam, 10)
      }
    },

    async initializeData() {
      try {
        this.loadingOverlay = true
        await Promise.all([
          this.getAgentes(),
          this.fetchList(),
        ])
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao carregar os dados iniciais.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.loadingOverlay = false
      }
    },

    async getAgentes() {
      const response = await store.dispatch('fechamento-relatorio-spot/getAgentes')
      this.agenteList = response.data
    },

    buscarFiltro() {
      // Se ID estiver preenchido, não validar datas
      if (this.dataBuscaFilter.id) {
        this.currentPage = 1
        this.fetchList()
        return
      }
      // Validação de datas apenas quando ID não estiver preenchido
      if (this.isDataRangeDias(this.dataBuscaFilter.inicio, this.dataBuscaFilter.fim, 367)) {
        this.currentPage = 1
        this.fetchList()
      }
    },

    async fetchList() {
      try {
        this.loadingOverlay = true

        // Se ID estiver preenchido, não processar datas
        if (this.dataBuscaFilter.id) {
          const params = {
            size: this.perPage,
            page: this.currentPage - 1,
            sortBy: this.sortBy,
            sortDesc: this.isSortDirDesc,
            status: '3',
            id: this.dataBuscaFilter.id,
          }

          const [resumoResponse, vendasResponse] = await Promise.all([
            store.dispatch('fechamento-relatorio-spot/getVendasResumo', params),
            store.dispatch('fechamento-relatorio-spot/getVendas', params),
          ])

          this.resumo = resumoResponse.data
          const { content, totalElements } = vendasResponse.data
          this.dataList = content
          this.totalCount = totalElements
          return
        }

        let dataInicio = this.dataBuscaFilter.inicio
        if (typeof (dataInicio) === 'string' || dataInicio instanceof String) {
          dataInicio = toIsoStringTimeZone(new Date(dataInicio.split('-')[0], dataInicio.split('-')[1] - 1, dataInicio.split('-')[2]))
        }

        let dataFim = this.dataBuscaFilter.fim

        if (typeof (dataFim) === 'string' || dataFim instanceof String) {
          const dataFimTemp = new Date(dataFim.split('-')[0], dataFim.split('-')[1] - 1, dataFim.split('-')[2])
          dataFim = new Date(dataFimTemp.setDate(dataFimTemp.getDate() + 1)).toISOString()
        } else {
          dataFim = new Date(dataFim.setDate(dataFim.getDate() + 1))
        }

        const paridadeTemp = this.paridade
        const params = {
          size: this.perPage,
          page: this.currentPage - 1,
          sortBy: this.sortBy,
          sortDesc: this.isSortDirDesc,
          dataInicio,
          dataFim,
          paridade: paridadeTemp,
          status: '3',
          coin: this.dataBuscaFilter.coin,
          agente: this.dataBuscaFilter.agente,
        }

        const [resumoResponse, vendasResponse] = await Promise.all([
          store.dispatch('fechamento-relatorio-spot/getVendasResumo', params),
          store.dispatch('fechamento-relatorio-spot/getVendas', params),
        ])

        this.resumo = resumoResponse.data
        const { content, totalElements } = vendasResponse.data
        this.dataList = content
        this.totalCount = totalElements
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao recuperar a lista.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.loadingOverlay = false
      }
    },
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

// Add some hover effects
.btn-icon {
  transition: transform 0.2s;
  &:hover {
    transform: translateY(-2px);
  }
}

// Improve table readability
.table {
  th {
    font-weight: 600;
    background-color: #f8f8f8;
  }
  td {
    vertical-align: middle;
  }
}

// Add card hover effects
.card {
  transition: box-shadow 0.2s;
  &:hover {
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  }
}
</style>
